import { render, staticRenderFns } from "./JobDetailsModal.vue?vue&type=template&id=2ab651b6&scoped=true"
import script from "./JobDetailsModal.vue?vue&type=script&lang=js"
export * from "./JobDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./JobDetailsModal.vue?vue&type=style&index=0&id=2ab651b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab651b6",
  null
  
)

export default component.exports